
<template>

    <v-container>

        <h1  class="text-xs-left" >Dashboard Home</h1>

  <v-layout row wrap>
    <v-flex xs6 v-for="no in [1,2,3,4]" :key="no" left class="pa-2" >

      <v-card >
        <v-img
          src="https://cdn.vuetifyjs.com/images/cards/desert.jpg"
          aspect-ratio="2.75"
        ></v-img>

        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Kangaroo Valley Safari</h3>
            <div>Located two hours south of Sydney in the <br>Southern Highlands of New South Wales, ...</div>
          </div>
        </v-card-title>

        <v-card-actions>
          <v-btn flat color="orange">Share</v-btn>
          <v-btn flat color="orange">Explore</v-btn>
        </v-card-actions>
      </v-card>
            <crud :embedprops="{params:{module:'permissao',action:'list'}, 
            props:{filtro:false,gc:false,rodape:false,paginacao:false, titulo:false, select:false,
            exportscreen:false, exportserver:false}}"/>



    </v-flex>
  </v-layout>
            <crud :embedprops="{params:{module:'venda',action:'list'}, 
            props:{filtro:false,gc:false,rodape:true,paginacao:false, titulo:false, select:false, 
            exportserver:false}}"/>

          <demo/>

          <metareport-teste/>

          <query tabela="cidade"/>

    </v-container>

</template>

<script>

export default {
  data() {
    return {
    };
  },
  methods: {
    
  },
  beforeMount(){
    if(this.$store.state.user==null){
      this.$router.replace({
        path:"/admin/login"
      })
    }
  },
  components:{
    Crud: global.reqClass.requirecmpmix("@/admin/listagem/crud.vue"),
    demo: global.reqClass.requirecmpmix("@/page/demo.vue"),
    metareportTeste: global.reqClass.requirecmpmix("@/page/metareport/teste.vue"),
    query:global.reqClass.requirecmpmix('@/page/query'),
  }
};
</script>

<style scoped>
</style>
